import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { Actions } from '../../actions';
import { DeactivateArtistSuccess } from '../action-creators';
import { DEACTIVATE_ARTIST_SUCCESS } from '../actions';
import { push } from 'connected-react-router';

export const deactivateArtistSuccessEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, DeactivateArtistSuccess>(DEACTIVATE_ARTIST_SUCCESS),
    map(() => {
      return push('/user/general');
    })
  );
